(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Landing-Hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    document.querySelector(".popupbuttonsplitter").addEventListener("click", function(event) {
        // Check if the element has "Mobile-popup-sp" and screen width <= 768px
        if (event.target.classList.contains("Mobile-popup-sp") && window.innerWidth <= 768) {
            document.body.classList.add("popupopen-sp", "mobile-popup-sp");
        }
        // Check if the element has "desktop-popup-sp", this will work on all screen sizes
        else if (event.target.classList.contains("desktop-popup-sp")) {
            document.body.classList.add("popupopen-sp");
        }
    });

    document.querySelectorAll(".overlay-popup-sp, .popup-close-btn-sp").forEach(function(element) {
        element.addEventListener("click", function() {
            // Remove both classes to reset the popup
            document.body.classList.remove("popupopen-sp", "mobile-popup-sp");
        });
    });
});



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Landing-Starter-Custom"] && !Shopify.designMode) return;
  try {
    
  // Scoped per section instance. Runs once when the section loads.
  (function () {
    var root = document.currentScript && document.currentScript.previousElementSibling;
    // Example: log that this landing section mounted. Replace with real behavior.
    console.log('[Landing-Starter-Custom] mounted');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero-section-4"] && !Shopify.designMode) return;
  try {
    
  /* Your JavaScript goes here */

  } catch(e) { console.error(e); }
})();
})();
